/**
 * フォーム送信完了画面。
 * 仕様書: docs/01_spec/spec_line_bot.md A-12.3（Phase 24b）
 */
import { CheckCircle2, ExternalLink } from 'lucide-react';

interface Props {
  message: string;
  brandColor?: string;
  backgroundColor?: string;
  logoUrl?: string;
  /** redirectUrl が指定されているときに表示。1.5 秒後に自動遷移される */
  redirectingTo?: string | null;
}

export function ThanksScreen({
  message,
  brandColor,
  backgroundColor,
  logoUrl,
  redirectingTo,
}: Props) {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
      <div
        className="max-w-md w-full rounded-lg bg-white border border-gray-200 p-8 text-center space-y-4 shadow-sm"
        style={backgroundColor ? { backgroundColor } : undefined}
      >
        {logoUrl && (
          <img src={logoUrl} alt="" className="max-h-16 mx-auto" />
        )}
        <CheckCircle2
          className="size-14 mx-auto"
          style={{ color: brandColor ?? '#10b981' }}
        />
        <h1 className="text-lg font-bold text-gray-900">送信完了</h1>
        <p className="text-[13px] text-gray-700 leading-relaxed whitespace-pre-wrap">
          {message}
        </p>
        {redirectingTo && (
          <div className="text-[11px] text-gray-500 flex items-center justify-center gap-1 pt-2 border-t border-gray-100">
            <ExternalLink className="size-3" />
            まもなくページを移動します…
          </div>
        )}
      </div>
    </div>
  );
}
